import React from 'react';
const HeaderPage = ({ title }) => {
  return <div class="text-30 fw-bold mb-3 text-black">{title}</div>;
};
export default HeaderPage;
